import * as Sentry from "@sentry/gatsby";

const isBrowser = typeof window !== "undefined";

const API_URLS = [
  "https://api.wewantjusticedao.org",
  "https://restcountries.com",
  "https://ipapi.co",
];

Sentry.init({
  dsn: "https://e29a67dc4283d3c58e93105ed86f0aa3@o1254623.ingest.us.sentry.io/4510695201832960",
  enabled: process.env.NODE_ENV === "production",
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: isBrowser
    ? [
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,

          networkDetailAllowUrls: [window.location.origin, ...API_URLS],

          networkRequestHeaders: ["Content-Type", "Authorization"],
          networkResponseHeaders: ["Content-Type", "X-Request-Id"],

          networkCaptureBodies: true,
        }),
        Sentry.breadcrumbsIntegration({
          console: true,
          dom: true,
          fetch: true,
          history: true,
          xhr: true,
        }),
      ]
    : [],

  environment: process.env.NODE_ENV || "development",

  ignoreErrors: [
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    "ResizeObserver loop",
  ],

  sendDefaultPii: true,

  beforeSend(event) {
    if (isBrowser) {
      event.contexts = {
        ...event.contexts,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      };
    }
    return event;
  },
});
